<template>
  <div class="container" :style="{'--bottomHeight': bottomHeight}">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      OMNI Assistant
    </div>

    <div class="content" ref="content" id="content">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          pulling-text="Pull down to refresh"
          loading-text="Loading..."
          success-text="Refresh success"
          loosing-text="Release to refresh"
      >

        <ChatItem
            v-for="(item,index) in chatList"
            :key="index"
            :chat-item="item"
            @onShowMedia="onShowMedia">
        </ChatItem>

      </van-pull-refresh>
    </div>

    <AssistantBottom :show-media-toolbar="showMediaToolbar" @onChatChange="onChatChange"
        @onShowToolBar="onShowToolBar"/>
    <VanPopup v-model="showPopup">
      <video ref="video"/>
    </VanPopup>
  </div>
</template>

<script>
import BrandProgress from "@/components/customization/BrandProgress.vue";
import AssistantBottom from "@/components/assistant/AssistantBottom.vue";
import CurveItem from "@/components/history/CurveItem.vue";
import assistant from "@/api/assistant";
import produce from "@/api/produce";
import ChatItem from "@/components/assistant/ChatItem.vue";
import { ImagePreview } from "vant";

export default {
  name: "index.vue",
  components: { ChatItem, CurveItem, AssistantBottom, BrandProgress },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 20,

      chatList: [],
      showPopup: false,
      currentSelectedMedia: {
        type: 2,
        content: ""
      },
      showMediaToolbar: false,
      isFirst: true
    };
  },
  methods: {
    onShowMedia(item) {
      ImagePreview({
            images: [item.content]
          }
      );
    },
    onShowToolBar() {
      this.showMediaToolbar = !this.showMediaToolbar;
      this.$nextTick(()=> {
        this.$refs.content.scrollTo(0, this.$refs.content.scrollHeight  - this.$refs.content.clientHeight);
      })
    },
    onClickHeaderReturn() {
      this.$router.back();
    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onLoad() {

      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const resp = await assistant.records({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }, this.isFirst);

        const { data, code, message, total } = resp;
        if (code !== 200) {
          throw message;
        }

        const chatList = data.reverse();
        this.chatList.unshift(...chatList);

        if (this.isFirst) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs.content.scrollTo(0, this.$refs.content.scrollHeight);
            });
          }, 300);
        }

        this.isEmpty = (total === 0);
        if (total !== 0) {
          this.isFirst = false;
        }
        //刷新结束
        if (this.refreshing) {
          this.refreshing = false;
        }
        if (data.length >= total) {
          this.finished = true;
        }
        this.pageNum += 1;

      } catch (e) {
        if (e instanceof String) {
          this.$dialog.alert({ message: e });
        } else if (e instanceof Error) {
          this.$dialog.alert({ message: e.message });
        }

        this.error = true;
      } finally {
        this.loading = false;
      }

    },
    onChatChange(item) {
      this.chatList.push(item);
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.content.scrollTo(0, this.$refs.content.scrollHeight);
        }, 100);

      });
    }
  },
  computed: {
    bottomHeight() {
      if (this.showMediaToolbar) {
        return "95px";
      }
      return "68px";
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>


<style scoped lang="less">
.van-popup {
  background: transparent;
}

.content {

  scroll-behavior: smooth; /* 启用平滑滚动 */
  padding-bottom: calc(var(--bottomHeight) + env(safe-area-inset-bottom));
  animation: all 0.3s ease-in;
}
</style>